import { getReportsData } from 'api/getReportsData';
import * as ReportTypes from '../features/frontoffice/actions/types';
import { formatReptSource } from './formatReptSource';


 const REPORT_VIEW_REGEX = /^\/bi\/(?:[^/]+\/)?([^/]+)\/view\/([^/]+)\/([^/?#]+)$/;


export const parseReportViewPath = (pathname = '') => {
  const match = pathname.match(REPORT_VIEW_REGEX);
  if (!match) return null;
  return {
    tenantCd: decodeURIComponent(match[1]),
    workbook: decodeURIComponent(match[2]),
    dashboard: decodeURIComponent(match[3])
  };
};


export const getReportOrigin = () => {
  try {
    return JSON.parse(sessionStorage.getItem('reportOrigin')) || {};
  } catch {
    return {};
  }
};

const getWorkbook = (card) => String(card?.reptSource || '').split('/')[0];


const findSameReport = (reports, workbook, title) => {
  const list = Array.isArray(reports) ? reports : [];
  return list.find((card) => getWorkbook(card).toLowerCase() === workbook.toLowerCase()) || (title ? list.find((card) => card?.displayText === title) : null) || null;
};


export const openReport = ({ card, tenantCd, tableauServiceUrl, navigate, dispatch, reportBaseUrl, reportOriginComponent = '', replace = false }) => {
  const [workbook, dashboard] = String(card?.reptSource || '').split('/');

  navigate(`/bi/${tenantCd}/view/${workbook}/${dashboard}`, { replace });

  dispatch({
    type: ReportTypes.OPEN_REPORT_VIEWER_REQUEST,
    reportUrl: card.reportSource ? card.reportSource : formatReptSource(tableauServiceUrl, tenantCd, card.reptSource),
    category: card.category,
    title: card.displayText,
    reportBaseUrl,
    report: card,
    reportOriginComponent
  });

  sessionStorage.setItem(
    'reportOrigin',
    JSON.stringify({
      reportBaseUrl,
      reportOriginComponent,
      reportTitle: card.displayText
    })
  );
};


export const switchReportToTenant = async ({
  pathname,
  newTenant, 
  currentReportTitle, 
  tableauServiceUrl,
  navigate,
  dispatch,
  showToast 
}) => {
  const current = parseReportViewPath(pathname);
  if (!current || !newTenant?.code) return;

  const { reportBaseUrl = '/bi', reportOriginComponent = '', reportTitle } = getReportOrigin();
  const reportName = currentReportTitle || reportTitle || current.workbook;

  let sameReport = null;
  try {

    const reports = await getReportsData();
    sameReport = findSameReport(reports, current.workbook, reportName);
    console.log('[tenanetSwitch reports]', reports.length, '|looking for', current.workbook, '|found sameReport:', sameReport, '|reportName:', reportName);
  } catch (error) {
    console.error('Error checking report for new tenant:', error);
  }

  if (sameReport) {
    openReport({
      card: sameReport,
      tenantCd: newTenant.code,
      tableauServiceUrl,
      navigate,
      dispatch,
      reportBaseUrl,
      reportOriginComponent,
      replace: true
    });
    window.scrollTo(0, 0);
    return;
  }

  navigate(reportBaseUrl, { replace: true });
  showToast?.(`"${reportName}" isn't available for ${newTenant.name || newTenant.code}.`, 'error');
};
